export default __webpack_public_path__ + "assets/static/data/spyne-docs-data.e006769974c361fc0ffffd3ded2b20f9.json";